module.exports = __webpack_public_path__ + "img/11.247e9013.png";